import React, {useEffect} from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';
import {useDispatch, useSelector} from 'react-redux';
import {logPageLoadEvents} from '@ibibo/analytics';
import {updatePreviousPageName} from '../../store/actions'
import {prevPageNameSelector} from '../../store/selectors'
import UserInfo from './containers/UserInfo';

import Onboarding from '../../stories/components/Onboarding/onboarding';

const HomePage = () => {

  useEffect(() => {
    scrollIntoView(document.getElementById('onboarding'), {
      block: 'start',
      behavior: 'auto'
    });
  }, []);

  

  const data = useSelector(prevPageNameSelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();

  useEffect(() => {
    const events = {
      eVar23: prevPageName,
      eVar24: "onboarding|mypartner",
      eVar37: "domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng",
    }
    logPageLoadEvents('onboarding:signup:landing', events);
    dispatch(updatePreviousPageName("onboarding:signup:landing"))
  }, [dispatch]);

  return (
    <Onboarding step={1}>
      <UserInfo />
    </Onboarding>
  );
};

export default HomePage;
